export enum Period {
    WEEK = 7,
    MONTH = 30,
    THREE_MONTH = 90,
}
